import React, { memo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, LogoutCustom } from "../Components";
import Icon from "../assets/icons/Icon";
import { logoutUser } from "../store/user/user-action";
import { uiActions } from "../store/ui/ui-slice";
import { Link } from "react-router-dom";

const Topbar = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  const { theme } = useSelector((state) => state.ui);

  const handleTheme = () => {
    const root = document.documentElement;
    const currentTheme = root.getAttribute("data-bs-theme");

    const newTheme = currentTheme === "dark" ? "light" : "dark";

    // Update the attribute on <html>
    root.setAttribute("data-bs-theme", newTheme);

    // Optionally, dispatch to Redux store if you need to store the theme state globally
    dispatch(uiActions.setTheme(newTheme));
  };

  const handleSideCollapsed = () => {
    const body = document.querySelector("body");
    const currentSize = body.getAttribute("data-sidebar-size");
    if (currentSize && currentSize !== "default") {
      body.setAttribute("data-sidebar-size", "default");
    } else {
      body.setAttribute("data-sidebar-size", "collapsed");
    }
  };

  const handleLogout = async () => {
    await logoutUser(dispatch);
  };

  return (
    <header className="topbar d-print-none">
      <div className="container-fluid">
        <nav
          className="topbar-custom d-flex justify-content-between"
          id="topbar-custom"
        >
          <ul className="topbar-item list-unstyled d-inline-flex align-items-center mb-0">
            <li>
              <Button
                className="nav-link mobile-menu-btn nav-icon"
                icon="MdMenu"
                onClick={handleSideCollapsed}
              />
            </li>
          </ul>
          <ul className="topbar-item list-unstyled d-inline-flex align-items-center mb-0">
            <li className="topbar-item">
              <button className="nav-link nav-icon" onClick={handleTheme}>
                {theme === "dark" ? (
                  <Icon name="FaRegMoon" className=" dark-mode" />
                ) : (
                  <Icon name="FaSun" className="light-mode" />
                )}
              </button>
            </li>
            <li className="dropdown topbar-item position-relative">
              <LogoutCustom name={user?.username} onClick={handleLogout} />
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default memo(Topbar);
